import { useEffect } from "react";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid2";
import { isEmpty } from "lodash";

import {
  DinaImageBox,
  DinaImageStyle,
  ReferralManagementBox,
} from "../styles/style";
import { MyAccountModel } from "../../../models/MyAccount";
import { getCurrnetPageFullPath, getUaserPageViewPayload, getValue } from "../../../utils";
import { GeneratedVideoUrlResponse } from "../../../models/api/Training";
import { dinaPageImage } from "../../../constants/ImagePaths";
import { height100PCT } from "../../../styles/mui/styles/heights";
import { UserPageTrack } from "../../../models/User";
import { ApplicationTitles } from "../../../constants/HomePage";
import { getValidMessageType } from "../../../constants/User";
import { redirectUri } from "../../../constants/Config";

export interface PropsFromState {
  referralManagementState: GeneratedVideoUrlResponse;
  loggedInUser: MyAccountModel;
}
export interface PropsFromDispatch {
  getDinaLaunchUrl: (email: string) => void;
  postUserPageTrack: (payload: UserPageTrack) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const ReferralManagement: React.FC<AllProps> = ({
  getDinaLaunchUrl,
  referralManagementState,
  loggedInUser,
  postUserPageTrack
}) => {
   
  useEffect(() => {
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.REFERRAL_MANAGEMENT),
        getCurrnetPageFullPath(),
        redirectUri,
        ""
      )
    );
    if (getValue(loggedInUser, "providerPortalUser")) {
      getDinaLaunchUrl(loggedInUser.providerPortalUser.email);
    }
  }, [loggedInUser]);

  return (
    <Grid container>
      {!isEmpty(getValue(referralManagementState, "response.url")) ? (
        <Box
          component="iframe"
          src={getValue(referralManagementState, "response.url")}
          title="Dina"
          sx={ReferralManagementBox}
        />
      ) : (
        <Grid container sx={{ margin: 0 }}>
          <Grid size={{ xs: 12 }} sx={height100PCT}>
            <Box sx={DinaImageBox}>
              <img src={dinaPageImage} style={DinaImageStyle} alt="Dina" />
            </Box>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default ReferralManagement;
